/**
 * Capa de Acceso a Datos (Data Access Logic - DL) para la dinámica "Light Show Pro".
 * Gestiona las peticiones HTTP (fetch) hacia el controlador LightShowController de la API.
 */

const Prepare = async (beatsPerMinute, framesSequence) => {
    try {
        // Preparamos el objeto con los datos exactos que espera el DTO en C#
        const dataToSend = {
            beatsPerMinute: beatsPerMinute,
            frames: framesSequence // Enviamos el arreglo de cuadros de animación
        }
        
        // Apuntamos al nuevo controlador exclusivo que creamos para el Light Show
        const response = await fetch(`${process.env.REACT_APP_API_URL}LightShow/prepare`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP (Ej. 400 Bad Request, 500 Internal Server Error)
            const errorData = await response.json()
            return { 
                success: false, 
                message: errorData.message || 'No ha sido posible enviar la configuración de los frames al servidor. Intenta nuevamente.' 
            }
        }
        
        const data = await response.json()
        
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Error de red al intentar conectar con el servidor para preparar el show.' }
    }
}

const Start = async (beatsPerMinute, framesSequence) => {
    try {
        const dataToSend = {
            beatsPerMinute: beatsPerMinute,
            frames: framesSequence
        };

        // Para Iniciar, no enviamos Body, ya que el servidor calculará el Timestamp exacto de arranque.
        const response = await fetch(`${process.env.REACT_APP_API_URL}LightShow/start`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            const errorData = await response.json()
            return { 
                success: false, 
                message: errorData.message || 'No ha sido posible arrancar el show de luces.' 
            }
        }
        
        const data = await response.json()
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Error de red al intentar iniciar el show de luces.' }
    }
}

const Stop = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}LightShow/stop`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        if (!response.ok) {
            const errorData = await response.json()
            return { 
                success: false, 
                message: errorData.message || 'No ha sido posible detener la dinámica.' 
            }
        }
        
        const data = await response.json()
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Error de red al intentar conectar con el servidor para detener el show.' }
    }
}

export { Prepare, Start, Stop };









// /**
//  * Capa de Acceso a Datos (Data Access Logic - DL) para la dinámica "Light Show Pro".
//  * Gestiona las peticiones HTTP (fetch) hacia el controlador LightShowController de la API.
//  */

// const Prepare = async (beatsPerMinute, backgroundColor) => {
//     try {
//         // Preparamos el objeto con los datos que espera el DTO en C#
//         const dataToSend = {
//             beatsPerMinute: beatsPerMinute,
//             backgroundColor: backgroundColor
//         }
        
//         const response = await fetch(`${process.env.REACT_APP_API_URL}lightshow/prepare`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(dataToSend)
//         })
        
//         if (!response.ok) {
//             // Manejar errores HTTP (Ej. 400, 500)
//             const errorData = await response.json()
//             return { 
//                 success: false, 
//                 message: errorData.message || 'No ha sido posible preparar la dinámica. Intenta nuevamente.' 
//             }
//         }
        
//         const data = await response.json()
        
//         // Retornar la respuesta exitosa
//         return { success: true, data: data }
//     } catch (error) {
//         return { success: false, message: 'Error de red al intentar conectar con el servidor.' }
//     }
// }

// const Start = async () => {
//     try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}lightshow/start`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             }
//             // No requiere body porque el servidor calcula el timestamp internamente
//         })
        
//         if (!response.ok) {
//             const errorData = await response.json()
//             return { 
//                 success: false, 
//                 message: errorData.message || 'No ha sido posible iniciar el show de luces.' 
//             }
//         }
        
//         const data = await response.json()
//         return { success: true, data: data }
//     } catch (error) {
//         return { success: false, message: 'Error de red al intentar conectar con el servidor.' }
//     }
// }

// const Stop = async () => {
//     try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}lightshow/stop`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             }
//         })
        
//         if (!response.ok) {
//             const errorData = await response.json()
//             return { 
//                 success: false, 
//                 message: errorData.message || 'No ha sido posible detener la dinámica.' 
//             }
//         }
        
//         const data = await response.json()
//         return { success: true, data: data }
//     } catch (error) {
//         return { success: false, message: 'Error de red al intentar conectar con el servidor.' }
//     }
// }

// export { Prepare, Start, Stop };









// const Prepare = async () => {
//     try {
//         // const dataToSend = {
//         //     id: id
//         // }
        
//         const response = await fetch(`${process.env.REACT_APP_API_URL}lightshow/prepare`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             //body: JSON.stringify(dataToSend)
//         })
        
//         if (!response.ok) {
//             // Manejar errores HTTP
//             const errorData = await response.json()
//             return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
//         }
        
//         //const data = await response.json()
        
//         // Retornar la respuesta exitosa
//         return { success: true, data: data } // o null
//     } catch (error) {
        
//     }
// }

// export { Prepare, Start, Stop };